import { AxiosResponse } from 'axios';
import { useCallback } from 'react';
import { ApiUrl } from '@/utils/constants';
import api from '@/utils/api';
import { getSigV4HeadersForGet } from '@/utils/cognito';
import { HandsUpInfoResponse } from '@/types/api/mypage/handsUpInfo';

/** Hands-up残債情報取得APIのURL */
const url = ApiUrl.Read.HANDSUP_INFO;

/**
 * Hands-up残債情報取得APIの呼び出しフック。
 * マンション向け活動報告や残債案内で使う導入設備の残債情報を取得する。
 *
 * @returns execute - API実行関数
 */
const useGetHandsupInfo = () => {
  const execute = useCallback(async (): Promise<AxiosResponse<HandsUpInfoResponse>> => {
    const headers = await getSigV4HeadersForGet(url);
    return api.get(url, headers);
  }, []);

  return { execute };
};

export default useGetHandsupInfo;
